import ConfirmationModal  from './confirmation-modal';

export default ConfirmationModal;